import React, { useEffect } from 'react';
import { useAuth } from '../context/AuthContext.tsx';

const Login: React.FC = () => {
  const { isAuthenticated, isLoading, login, user } = useAuth();

  useEffect(() => {
    // If user is already authenticated, redirect to home
    if (isAuthenticated) {
      window.location.href = '/';
    }
  }, [isAuthenticated]);

  const handleLogin = async () => {
    try {
      await login();
    } catch (error) {
      if (process.env.NODE_ENV === 'development') {
        console.error('Login failed:', error);
      }
    }
  };

  if (isLoading) {
    return (
      <div className="login-container">
        <div className="login-form">
          <div className="auth-header">
            <img src="/astra_logo.png" alt="YH Logo" className="auth-logo" />
            <h3>盈紘有限公司帳號管理系統</h3>
          </div>
          <div className="loading">
            <p>載入中...</p>
          </div>
        </div>
      </div>
    );
  }

  if (isAuthenticated && user) {
    return (
      <div className="login-container">
        <div className="login-form">
          <div className="auth-header">
            <img src="/astra_logo.png" alt="YH Logo" className="auth-logo" />
            <h3>盈紘有限公司帳號管理系統</h3>
          </div>
          <div className="auth-success">
            <p>歡迎，{user.username}！</p>
            <p>正在重定向到主頁...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="login-container">
      <div className="login-form">
        <div className="auth-header">
          <img src="/astra_logo.png" alt="YH Logo" className="auth-logo" />
          <h3>盈紘有限公司帳號管理系統</h3>
        </div>
        <div className="login-content">
          <h2>使用者登入 - User Login</h2>
          <p>請點擊下方按鈕使用 AWS Cognito 登入</p>
          <button 
            onClick={handleLogin}
            className="login-button"
            disabled={isLoading}
          >
            {isLoading ? '登入中...' : '登入 / Login'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Login;